grabIGICertData()
function grabIGICertData(){
  try {
    $(".siteLoader").show();
    var getReportNumber = getParameterByName("rtn")
    getReportNumber = atob(getReportNumber); /* Decoding Cert Number */
    $.ajax({
      url: `${portalApiUrl}/get-igi-cert-data/${getReportNumber}`,
      type: "GET",
      success: function(result) {
        var reportData = result.data[0];
        if(!reportData.Value && reportData !== 'e'){
          var reportHTML = `
            <div class="report report-left">
              <div class="overlay"></div>
              <h2 class="title-left">Report</h2>
              <h5>Issue Date / <span class="bold-text">${reportData['REPORT DATE']}</span></h5>
              <h3 class="table-title">Report Summary</h3>
              <table class="report-table">
                <tr>
                  <td>Description</td>
                  <td class="text-right bold-text">${reportData['DESCRIPTION']}</td>
                </tr>
                <tr>
                  <td>Shape and Cutting Style</td>
                  <td class="text-right bold-text">${reportData['SHAPE AND CUT']}</td>
                </tr>
              </table>
              <h3 class="table-title">Grading Results</h3>
              <table class="report-table">
                <tr>
                  <td>Measurements</td>
                  <td class="text-right bold-text">${reportData['Measurements']}</td>
                </tr>
                <tr>
                  <td>Carat Weight</td>
                  <td class="text-right bold-text">${reportData['CARAT WEIGHT']}</td>
                </tr>
                <tr>
                  <td>Color Grade</td>
                  <td class="text-right bold-text">${reportData['COLOR GRADE']}</td>
                </tr>
                <tr>
                  <td>Clarity Grade</td>
                  <td class="text-right bold-text">${reportData['CLARITY GRADE']}</td>
                </tr>
              </table>
              <h3 class="table-title">Additional Grading Information</h3>
              <table class="report-table">
                <tr>
                  <td>Polish</td>
                  <td class="text-right bold-text">${reportData['POLISH']}</td>
                </tr>
                <tr>
                  <td>Symmetry</td>
                  <td class="text-right bold-text">${reportData['SYMMETRY']}</td>
                </tr>
                <tr>
                  <td>Measurements</td>
                  <td class="text-right bold-text">${reportData['Measurements']}</td>
                </tr>
                <tr>
                  <td>Fluorescence</td>
                  <td class="text-right bold-text">${reportData['FLUORESCENCE']}</td>
                </tr>
                <tr>
                  <td>Comments</td>
                  <td class="text-right bold-text">
                    ${reportData['COMMENTS']}
                  </td>
                </tr>
              </table>
            </div>
            <div class="report report-right padtop">
              <h2 class="title-right">Proportions</h2>
              <div class="diamond_proportion_image">
                <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/Group_1538235907.png?v=1728297172" />
                <span class="diamond-top-first-text">${reportData['Girdle Thickness']}</span>
                <span class="diamond-top-second-text">${reportData['Table Size']}</span>
                <span class="diamond-bottom-text">${reportData['Culet']}</span>
                <span class="diamond-left-text">${reportData['Total Depth']}</span>
              </div>
              <h4 class="title-right-md">Grading Scale</h4>
              <h4 class="title-right-md">Color</h4>
              <ul class="tablelist">
                <li>
                  <div class="font-bold">D - F</div>
                  <div>Colorless</div>
                </li>
                <li>
                  <div class="font-bold">G - J</div>
                  <div>Near Colorless</div>
                </li>
                <li>
                  <div class="font-bold">K - M</div>
                  <div>Slightly Tinted</div>
                </li>
                <li>
                  <div class="font-bold">N - P</div>
                  <div>Very Light Color</div>
                </li>
                <li>
                  <div class="font-bold">S - Z</div>
                  <div>Light Color </div>
                </li>
                <li>
                  <div class="font-bold"> FANCY</div>
                  <div></div>
                </li>
              </ul>
              <h4 class="title-right-md">Clarity</h4>
              <ul class="tablelist">
                <li>
                  <div class="font-bold">IF</div>
                  <div>Internally Flawless</div>
                </li>
                <li>
                  <div class="font-bold">VVS 1-2</div>
                  <div>Very Very Slightly Included</div>
                </li>
                <li>
                  <div class="font-bold">VS 1-2</div>
                  <div>Very Slightly Included</div>
                </li>
                <li>
                  <div class="font-bold">SI 1-2</div>
                  <div>Slightly Included</div>
                </li>
                <li>
                  <div class="font-bold">I 1-3</div>
                  <div>Included</div>
                </li>
              </ul>
            </div>`;
          // Append the HTML content to the desired div
          $(".igi-certificate-main-section").append(reportHTML);
          $(".igi-cert-details").removeClass('hide')
          $(".siteLoader").hide();
        } else {
          $('.igi-certificate-main-section').addClass('hide');
          $('.no-data-found, .igi-cert-details').removeClass('hide');
          $(".siteLoader").hide();
        }
      },
      error: function(error) {
        console.error(error);
        $('.igi-certificate-main-section').addClass('hide');
        $('.no-data-found, .igi-cert-details').removeClass('hide');
        $(".siteLoader").hide();
      }
    });
  } catch (error) {
    console.error('Caught an exception during AJAX request:', error);
    $('.igi-certificate-main-section').addClass('hide');
    $('.no-data-found, .igi-cert-details').removeClass('hide');
    $(".siteLoader").hide();
  }
}

function manageSummaryContent() {
  $('#diamondCreationBtn').removeClass('tabs-card-btn-active');
  $('#summaryBtn').addClass('tabs-card-btn-active');
  $('.diamond-creation-details').addClass('hide');
  $('.igi-certificate-main-section').removeClass('hide');
}

function manageDiamondContent() {
  $('#diamondCreationBtn').addClass('tabs-card-btn-active');
  $('#summaryBtn').removeClass('tabs-card-btn-active');
  $('.diamond-creation-details').removeClass('hide');
  $('.igi-certificate-main-section').addClass('hide');
}